<template>
  <svg class="alerts-icon" viewBox="0 0 18 18" aria-hidden="true" focusable="false">
    <template v-if="name === 'chat'"><path d="M3 4.5h12v7.5H8l-3.5 2.8V12H3z" /></template>
    <template v-else-if="name === 'digest'"><rect x="3" y="2.8" width="12" height="12.4" rx="1.5" /><path d="M6 6.5h6M6 9h6M6 11.5h3.5" /></template>
    <template v-else-if="name === 'clock'"><circle cx="9" cy="9" r="6.5" /><path d="M9 5.5V9l2.5 1.5" /></template>
    <template v-else-if="name === 'shield'"><path d="M9 2.2 14.5 4v4.6c0 3.4-2.3 5.8-5.5 7.2-3.2-1.4-5.5-3.8-5.5-7.2V4z" /><path d="M6.6 9.2l1.7 1.7 3.2-3.4" /></template>
    <template v-else-if="name === 'check'"><path d="M4 9.5l3 3 7-7" /></template>
    <template v-else-if="name === 'more'"><path d="M4.5 9h.01M9 9h.01M13.5 9h.01" stroke-width="3.2" /></template>
    <template v-else-if="name === 'chev'"><path d="M5 7l4 4 4-4" /></template>
    <template v-else-if="name === 'chevr'"><path d="M7 5l4 4-4 4" /></template>
    <template v-else-if="name === 'wrench'"><path d="M11.8 2.6a3.6 3.6 0 0 0-4.4 4.6L2.8 11.8a1.5 1.5 0 0 0 2.1 2.1l4.6-4.6a3.6 3.6 0 0 0 4.6-4.4l-2.1 2.1-2-.5-.5-2z" /></template>
    <template v-else-if="name === 'tri'"><path d="M9 2.5 16 15H2z" /><path d="M9 7.5v3.5M9 13v.01" /></template>
    <template v-else-if="name === 'search'"><circle cx="8" cy="8" r="4.5" /><path d="M11.5 11.5 15 15" /></template>
    <template v-else><circle cx="9" cy="9" r="6.5" /><path d="M9 8v4M9 6v.01" /></template>
  </svg>
</template>

<script setup>
// The workspace's stroke icons (brief §3.3: "the icon language is the
// reference, not the glyph shapes"). Decorative — every icon sits next to
// text that says the same thing.
defineProps({ name: { type: String, default: 'info' } });
</script>

<style lang="scss">
.alerts-icon {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
